
export const chartDataIcons = {
  "Histogram": "BarChart2",
  "PieDonut": "Donut",
  "ParallelSets": "AlignHorizontalSpaceBetween",
  "Line": "LineChart",
  "TreeMap": "LayoutGrid",
  "GroupedBarChart": "BarChart3",
  "ScatterPlot": "ScatterChart"
}


export const revenueData = [
  { name: '2020', apples: 3840, bananas: 1920, cherries: 960, dates: 400 },
  { name: '2021', apples: 1600, bananas: 1440, cherries: 960, dates: 400 },
  { name: '2022', apples: 640, bananas: 960, cherries: 640, dates: 400 },
  { name: '2023', apples: 320, bananas: 480, cherries: 640, dates: 400 },
];

export const salesData = [
  { name: 'Jan', sales: 1200, profit: 800, expenses: 400 },
  { name: 'Feb', sales: 1400, profit: 900, expenses: 500 },
  { name: 'Mar', sales: 1600, profit: 1100, expenses: 500 },
  { name: 'Apr', sales: 1800, profit: 1200, expenses: 600 },
  { name: 'May', sales: 2000, profit: 1400, expenses: 600 },
  { name: 'Jun', sales: 2200, profit: 1600, expenses: 600 },
];

export const pieDonutData = [
  { label: "Desktop", value: 45 },
  { label: "Mobile", value: 35 },
  { label: "Tablet", value: 15 },
  { label: "Other", value: 5 }
];

export const categoryData = [
  { label: "Electronics", value: 30 },
  { label: "Clothing", value: 25 },
  { label: "Books", value: 20 },
  { label: "Home & Garden", value: 15 },
  { label: "Sports", value: 10 }
];

export const monthlyTrends = [
  { name: 'Jan', revenue: 12000, users: 800, orders: 150 },
  { name: 'Feb', revenue: 14000, users: 900, orders: 170 },
  { name: 'Mar', revenue: 16000, users: 1000, orders: 190 },
  { name: 'Apr', revenue: 18000, users: 1100, orders: 210 },
  { name: 'May', revenue: 20000, users: 1200, orders: 230 },
  { name: 'Jun', revenue: 22000, users: 1300, orders: 250 },
];

export const progressCircleData = [
  { value: 75, label: null }
];

export const histogramData = [
  // Customer Age Distribution (18-65)
  { value: 22 }, { value: 23 }, { value: 24 }, { value: 25 }, { value: 26 }, { value: 27 }, { value: 28 }, { value: 29 },
  { value: 30 }, { value: 31 }, { value: 32 }, { value: 33 }, { value: 34 }, { value: 35 }, { value: 36 }, { value: 37 },
  { value: 38 }, { value: 39 }, { value: 40 }, { value: 41 }, { value: 42 }, { value: 43 }, { value: 44 }, { value: 45 },
  { value: 46 }, { value: 47 }, { value: 48 }, { value: 49 }, { value: 50 }, { value: 51 }, { value: 52 }, { value: 53 },
  { value: 54 }, { value: 55 }, { value: 56 }, { value: 57 }, { value: 58 }, { value: 59 }, { value: 60 }, { value: 61 },
  { value: 62 }, { value: 63 }, { value: 64 }, { value: 65 },
  
  // Purchase Amount Distribution ($10-$500)
  { value: 15 }, { value: 18 }, { value: 22 }, { value: 25 }, { value: 28 }, { value: 32 }, { value: 35 }, { value: 38 },
  { value: 42 }, { value: 45 }, { value: 48 }, { value: 52 }, { value: 55 }, { value: 58 }, { value: 62 }, { value: 65 },
  { value: 68 }, { value: 72 }, { value: 75 }, { value: 78 }, { value: 82 }, { value: 85 }, { value: 88 }, { value: 92 },
  { value: 95 }, { value: 98 }, { value: 102 }, { value: 105 }, { value: 108 }, { value: 112 }, { value: 115 }, { value: 118 },
  { value: 122 }, { value: 125 }, { value: 128 }, { value: 132 }, { value: 135 }, { value: 138 }, { value: 142 }, { value: 145 },
  { value: 148 }, { value: 152 }, { value: 155 }, { value: 158 }, { value: 162 }, { value: 165 }, { value: 168 }, { value: 172 },
  { value: 175 }, { value: 178 }, { value: 182 }, { value: 185 }, { value: 188 }, { value: 192 }, { value: 195 }, { value: 198 },
  { value: 202 }, { value: 205 }, { value: 208 }, { value: 212 }, { value: 215 }, { value: 218 }, { value: 222 }, { value: 225 },
  { value: 228 }, { value: 232 }, { value: 235 }, { value: 238 }, { value: 242 }, { value: 245 }, { value: 248 }, { value: 252 },
  { value: 255 }, { value: 258 }, { value: 262 }, { value: 265 }, { value: 268 }, { value: 272 }, { value: 275 }, { value: 278 },
  { value: 282 }, { value: 285 }, { value: 288 }, { value: 292 }, { value: 295 }, { value: 298 }, { value: 302 }, { value: 305 },
  { value: 308 }, { value: 312 }, { value: 315 }, { value: 318 }, { value: 322 }, { value: 325 }, { value: 328 }, { value: 332 },
  { value: 335 }, { value: 338 }, { value: 342 }, { value: 345 }, { value: 348 }, { value: 352 }, { value: 355 }, { value: 358 },
  { value: 362 }, { value: 365 }, { value: 368 }, { value: 372 }, { value: 375 }, { value: 378 }, { value: 382 }, { value: 385 },
  { value: 388 }, { value: 392 }, { value: 395 }, { value: 398 }, { value: 402 }, { value: 405 }, { value: 408 }, { value: 412 },
  { value: 415 }, { value: 418 }, { value: 422 }, { value: 425 }, { value: 428 }, { value: 432 }, { value: 435 }, { value: 438 },
  { value: 442 }, { value: 445 }, { value: 448 }, { value: 452 }, { value: 455 }, { value: 458 }, { value: 462 }, { value: 465 },
  { value: 468 }, { value: 472 }, { value: 475 }, { value: 478 }, { value: 482 }, { value: 485 }, { value: 488 }, { value: 492 },
  { value: 495 }, { value: 498 },
  
  // Session Duration (minutes)
  { value: 2.5 }, { value: 3.2 }, { value: 3.8 }, { value: 4.1 }, { value: 4.5 }, { value: 4.8 }, { value: 5.2 }, { value: 5.6 },
  { value: 6.1 }, { value: 6.5 }, { value: 6.9 }, { value: 7.3 }, { value: 7.8 }, { value: 8.2 }, { value: 8.6 }, { value: 9.1 },
  { value: 9.5 }, { value: 9.9 }, { value: 10.3 }, { value: 10.8 }, { value: 11.2 }, { value: 11.6 }, { value: 12.1 }, { value: 12.5 },
  { value: 12.9 }, { value: 13.3 }, { value: 13.8 }, { value: 14.2 }, { value: 14.6 }, { value: 15.1 }, { value: 15.5 }, { value: 15.9 },
  { value: 16.3 }, { value: 16.8 }, { value: 17.2 }, { value: 17.6 }, { value: 18.1 }, { value: 18.5 }, { value: 18.9 }, { value: 19.3 },
  { value: 19.8 }, { value: 20.2 }, { value: 20.6 }, { value: 21.1 }, { value: 21.5 }, { value: 21.9 }, { value: 22.3 }, { value: 22.8 },
  { value: 23.2 }, { value: 23.6 }, { value: 24.1 }, { value: 24.5 }, { value: 24.9 }, { value: 25.3 }, { value: 25.8 }, { value: 26.2 },
  { value: 26.6 }, { value: 27.1 }, { value: 27.5 }, { value: 27.9 }, { value: 28.3 }, { value: 28.8 }, { value: 29.2 }, { value: 29.6 },
  { value: 30.1 }, { value: 30.5 }, { value: 30.9 }, { value: 31.3 }, { value: 31.8 }, { value: 32.2 }, { value: 32.6 }, { value: 33.1 },
  { value: 33.5 }, { value: 33.9 }, { value: 34.3 }, { value: 34.8 }, { value: 35.2 }, { value: 35.6 }, { value: 36.1 }, { value: 36.5 },
  { value: 36.9 }, { value: 37.3 }, { value: 37.8 }, { value: 38.2 }, { value: 38.6 }, { value: 39.1 }, { value: 39.5 }, { value: 39.9 },
  { value: 40.3 }, { value: 40.8 }, { value: 41.2 }, { value: 41.6 }, { value: 42.1 }, { value: 42.5 }, { value: 42.9 }, { value: 43.3 },
  { value: 43.8 }, { value: 44.2 }, { value: 44.6 }, { value: 45.1 }, { value: 45.5 }, { value: 45.9 }, { value: 46.3 }, { value: 46.8 },
  { value: 47.2 }, { value: 47.6 }, { value: 48.1 }, { value: 48.5 }, { value: 48.9 }, { value: 49.3 }, { value: 49.8 }, { value: 50.2 },
  { value: 50.6 }, { value: 51.1 }, { value: 51.5 }, { value: 51.9 }, { value: 52.3 }, { value: 52.8 }, { value: 53.2 }, { value: 53.6 },
  { value: 54.1 }, { value: 54.5 }, { value: 54.9 }, { value: 55.3 }, { value: 55.8 }, { value: 56.2 }, { value: 56.6 }, { value: 57.1 },
  { value: 57.5 }, { value: 57.9 }, { value: 58.3 }, { value: 58.8 }, { value: 59.2 }, { value: 59.6 }, { value: 60.1 }, { value: 60.5 },
  { value: 60.9 }, { value: 61.3 }, { value: 61.8 }, { value: 62.2 }, { value: 62.6 }, { value: 63.1 }, { value: 63.5 }, { value: 63.9 },
  { value: 64.3 }, { value: 64.8 }, { value: 65.2 }, { value: 65.6 }, { value: 66.1 }, { value: 66.5 }, { value: 66.9 }, { value: 67.3 },
  { value: 67.8 }, { value: 68.2 }, { value: 68.6 }, { value: 69.1 }, { value: 69.5 }, { value: 69.9 }, { value: 70.3 }, { value: 70.8 },
  { value: 71.2 }, { value: 71.6 }, { value: 72.1 }, { value: 72.5 }, { value: 72.9 }, { value: 73.3 }, { value: 73.8 }, { value: 74.2 },
  { value: 74.6 }, { value: 75.1 }, { value: 75.5 }, { value: 75.9 }, { value: 76.3 }, { value: 76.8 }, { value: 77.2 }, { value: 77.6 },
  { value: 78.1 }, { value: 78.5 }, { value: 78.9 }, { value: 79.3 }, { value: 79.8 }, { value: 80.2 }, { value: 80.6 }, { value: 81.1 },
  { value: 81.5 }, { value: 81.9 }, { value: 82.3 }, { value: 82.8 }, { value: 83.2 }, { value: 83.6 }, { value: 84.1 }, { value: 84.5 },
  { value: 84.9 }, { value: 85.3 }, { value: 85.8 }, { value: 86.2 }, { value: 86.6 }, { value: 87.1 }, { value: 87.5 }, { value: 87.9 },
  { value: 88.3 }, { value: 88.8 }, { value: 89.2 }, { value: 89.6 }, { value: 90.1 }, { value: 90.5 }, { value: 90.9 }, { value: 91.3 },
  { value: 91.8 }, { value: 92.2 }, { value: 92.6 }, { value: 93.1 }, { value: 93.5 }, { value: 93.9 }, { value: 94.3 }, { value: 94.8 },
  { value: 95.2 }, { value: 95.6 }, { value: 96.1 }, { value: 96.5 }, { value: 96.9 }, { value: 97.3 }, { value: 97.8 }, { value: 98.2 },
  { value: 98.6 }, { value: 99.1 }, { value: 99.5 }, { value: 99.9 }
]; 

export const treeMapData = {
  name: "Revenue",
  children: [
    {
      name: "Electronics",
      children: [
        { name: "Smartphones", value: 1250000 },
        { name: "Laptops", value: 980000 },
        { name: "Tablets", value: 650000 },
        { name: "Accessories", value: 420000 },
        { name: "Gaming", value: 380000 }
      ]
    },
    {
      name: "Clothing",
      children: [
        { name: "Men's Apparel", value: 890000 },
        { name: "Women's Apparel", value: 1120000 },
        { name: "Kids Clothing", value: 450000 },
        { name: "Shoes", value: 680000 },
        { name: "Accessories", value: 320000 }
      ]
    },
    {
      name: "Home & Garden",
      children: [
        { name: "Furniture", value: 750000 },
        { name: "Kitchen", value: 520000 },
        { name: "Decor", value: 380000 },
        { name: "Outdoor", value: 290000 },
        { name: "Tools", value: 180000 }
      ]
    },
    {
      name: "Books & Media",
      children: [
        { name: "Fiction", value: 420000 },
        { name: "Non-Fiction", value: 380000 },
        { name: "Educational", value: 290000 },
        { name: "Digital Media", value: 250000 },
        { name: "Magazines", value: 120000 }
      ]
    },
    {
      name: "Sports & Outdoors",
      children: [
        { name: "Fitness", value: 580000 },
        { name: "Outdoor Gear", value: 420000 },
        { name: "Team Sports", value: 350000 },
        { name: "Swimming", value: 220000 },
        { name: "Cycling", value: 180000 }
      ]
    },
    {
      name: "Health & Beauty",
      children: [
        { name: "Skincare", value: 680000 },
        { name: "Makeup", value: 520000 },
        { name: "Haircare", value: 380000 },
        { name: "Fragrances", value: 290000 },
        { name: "Supplements", value: 220000 }
      ]
    }
  ]
}; 

export const icicleData = {
  name: "File System",
  children: [
    {
      name: "Applications",
      children: [
        {
          name: "Productivity",
          children: [
            { name: "Microsoft Office", value: 2500000 },
            { name: "Adobe Creative Suite", value: 1800000 },
            { name: "Google Workspace", value: 1200000 },
            { name: "Slack", value: 800000 }
          ]
        },
        {
          name: "Development",
          children: [
            { name: "Visual Studio Code", value: 1500000 },
            { name: "IntelliJ IDEA", value: 1200000 },
            { name: "Sublime Text", value: 600000 },
            { name: "Atom", value: 400000 }
          ]
        },
        {
          name: "Design",
          children: [
            { name: "Figma", value: 900000 },
            { name: "Sketch", value: 700000 },
            { name: "InVision", value: 500000 },
            { name: "Zeplin", value: 300000 }
          ]
        }
      ]
    },
    {
      name: "Documents",
      children: [
        {
          name: "Work",
          children: [
            { name: "Reports", value: 800000 },
            { name: "Presentations", value: 600000 },
            { name: "Spreadsheets", value: 1200000 },
            { name: "Contracts", value: 400000 }
          ]
        },
        {
          name: "Personal",
          children: [
            { name: "Photos", value: 2000000 },
            { name: "Videos", value: 3500000 },
            { name: "Music", value: 1500000 },
            { name: "Books", value: 800000 }
          ]
        }
      ]
    },
    {
      name: "System",
      children: [
        {
          name: "Operating System",
          children: [
            { name: "macOS", value: 5000000 },
            { name: "Windows", value: 3000000 },
            { name: "Linux", value: 1000000 }
          ]
        },
        {
          name: "Drivers",
          children: [
            { name: "Graphics", value: 800000 },
            { name: "Audio", value: 400000 },
            { name: "Network", value: 300000 },
            { name: "Storage", value: 200000 }
          ]
        }
      ]
    }
  ]
}; 

export const hexChartData = [
  { x: 60, y: 60, value: 10, label: 'A' },
  { x: 120, y: 60, value: 20, label: 'B' },
  { x: 180, y: 60, value: 30, label: 'C' },
  { x: 90, y: 110, value: 15, label: 'D' },
  { x: 150, y: 110, value: 25, label: 'E' },
  { x: 210, y: 110, value: 35, label: 'F' },
  { x: 60, y: 160, value: 12, label: 'G' },
  { x: 120, y: 160, value: 22, label: 'H' },
  { x: 180, y: 160, value: 32, label: 'I' },
  { x: 90, y: 210, value: 18, label: 'J' },
  { x: 150, y: 210, value: 28, label: 'K' },
  { x: 210, y: 210, value: 38, label: 'L' },
]; 

export const stackedBarData = [
  { state: 'CA', age: '0-18', population: 1200000 },
  { state: 'CA', age: '19-35', population: 1800000 },
  { state: 'CA', age: '36-65', population: 1500000 },
  { state: 'CA', age: '65+', population: 800000 },
  { state: 'TX', age: '0-18', population: 900000 },
  { state: 'TX', age: '19-35', population: 1400000 },
  { state: 'TX', age: '36-65', population: 1200000 },
  { state: 'TX', age: '65+', population: 600000 },
  { state: 'NY', age: '0-18', population: 700000 },
  { state: 'NY', age: '19-35', population: 1100000 },
  { state: 'NY', age: '36-65', population: 1000000 },
  { state: 'NY', age: '65+', population: 500000 },
  { state: 'FL', age: '0-18', population: 800000 },
  { state: 'FL', age: '19-35', population: 1000000 },
  { state: 'FL', age: '36-65', population: 900000 },
  { state: 'FL', age: '65+', population: 700000 },
]; 

export const scatterPlotData = [
  // Height vs Weight data
  { x: 62, y: 120, label: 'A' },
  { x: 64, y: 135, label: 'B' },
  { x: 66, y: 145, label: 'C' },
  { x: 68, y: 155, label: 'D' },
  { x: 70, y: 165, label: 'E' },
  { x: 72, y: 175, label: 'F' },
  { x: 74, y: 185, label: 'G' },
  { x: 76, y: 195, label: 'H' },
  { x: 78, y: 205, label: 'I' },
  { x: 80, y: 215, label: 'J' },
  { x: 65, y: 140, label: 'K' },
  { x: 67, y: 150, label: 'L' },
  { x: 69, y: 160, label: 'M' },
  { x: 71, y: 170, label: 'N' },
  { x: 73, y: 180, label: 'O' },
  { x: 75, y: 190, label: 'P' },
  { x: 77, y: 200, label: 'Q' },
  { x: 79, y: 210, label: 'R' },
  { x: 63, y: 125, label: 'S' },
  { x: 65, y: 135, label: 'T' },
  { x: 67, y: 145, label: 'U' },
  { x: 69, y: 155, label: 'V' },
  { x: 71, y: 165, label: 'W' },
  { x: 73, y: 175, label: 'X' },
  { x: 75, y: 185, label: 'Y' },
  { x: 77, y: 195, label: 'Z' },
  { x: 79, y: 205, label: 'AA' },
  { x: 81, y: 215, label: 'BB' },
  { x: 66, y: 130, label: 'CC' },
  { x: 68, y: 140, label: 'DD' },
  { x: 70, y: 150, label: 'EE' },
  { x: 72, y: 160, label: 'FF' },
  { x: 74, y: 170, label: 'GG' },
  { x: 76, y: 180, label: 'HH' },
  { x: 78, y: 190, label: 'II' },
  { x: 80, y: 200, label: 'JJ' },
  { x: 82, y: 210, label: 'KK' },
  { x: 64, y: 115, label: 'LL' },
  { x: 66, y: 125, label: 'MM' },
  { x: 68, y: 135, label: 'NN' },
  { x: 70, y: 145, label: 'OO' },
  { x: 72, y: 155, label: 'PP' },
  { x: 74, y: 165, label: 'QQ' },
  { x: 76, y: 175, label: 'RR' },
  { x: 78, y: 185, label: 'SS' },
  { x: 80, y: 195, label: 'TT' },
  { x: 82, y: 205, label: 'UU' },
]; 